export default {
	login: "login",
	refreshToken: "refreshToken",
	getUserInfos: "getUserInfos",
};
